import React, { Component } from 'react'

import './SiteBanner.sass'


class SiteBanner extends Component {
  state = {
    isVisible: false
  }

  constructor() {
    super()
    this._hideBanner = this.hideBanner.bind(this)
  }

  hideBanner() {
    this.setState({ isVisible: false })
  }

  render() {
    const { isVisible } = this.state

    return (
      <section className={`site-banner ${isVisible ? '' : 'is-hidden'}`}>
        <h5>
          Thank you for visiting Gulf TREE! We are working on site updates, so please check back in a couple weeks for new features.
        </h5>
        <button
          type="button"
          aria-label="close"
          className="close-btn"
          onClick={this._hideBanner}
        >
          &#10005;
        </button>
      </section>
    );
  }
}

export default SiteBanner
